<template>
  <form-item v-bind="$attrs" v-on="$listeners">
    <el-input type="textarea" :rows="4" v-model="model[$attrs.prop]" maxlength="200" resize="none"></el-input>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'

  export default {
    name: 'TextareaFormItem',
    components: { FormItem },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
